<template>
	<component :is="this.context || 'div'"></component>
</template>

<script>
import AdminDashboardLandingZone from '@/components/ui/dashboard/admin/AdminDashboardLandingZone';

import { bus } from '@/main';

export default {
	name: 'LocumDashboardMain',
	components: {
		AdminDashboardLandingZone,
	},
	data: () => ({
		context: 'admin-dashboard-landing-zone', //begin in landing zone
	}),
	created() {
		bus.$on('change-context', new_context => {
			this.context = new_context;
		});
	},
	beforeDestroy() {
		// bus.$off('intent:submit-forms');
	},
	methods: {},
};
</script>
